import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    position: "relative",
  },

  leftSide: {},

  mainPage: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "99.5%",
    padding: "20px 72px",
  },

  snackbar_container: {
    left: "45%",
    top: "100px",
    position: "fixed",
    zIndex: 100,
  },

  rightSide: {
    height: "100%",
    minWidth: "420px",
  },

  stepper_container: {
    marginBottom: "32px",
  },

  title_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "32px",
    position: "relative",
  },

  temperature_titles_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
    position: "relative",
  },
  temp_left_title: {
    color: "#353535",
    fontSize: "14px",
    letterSpacing: 0,
  },
  temp_right_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#353535",
    fontSize: "16px",
    letterSpacing: 0,
    gap: "5px",
  },

  tempArray_container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "18px",
    marginBottom: "22px",
  },

  sliders_container: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
    marginBottom: "50px",
    gap: "12px",
    padding: "20px 0px",
    borderRadius: "6px",
    boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
  },

  sliders_container_mobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginBottom: "40px",
    gap: "16px",
    padding: "24px 0px",
    boxShadow: "0 0 6px 0 rgba(0,0,0,0.15)",
  },

  warning_container: {
    width: "100%",
    marginBottom: "16px",
  },
  buttons_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "20px",
  },
  buttons_rightSide: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
  },

  //--------------------------------Mobile-----------------------------------
  mainPage_mobile: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "0px 20px",
  },

  header_mobile: {
    width: "100%",
  },

  wrapperForHeader: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
  },

  title_container_mobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column-reverse",
    width: "100%",
    marginBottom: "24px",
  },

  temperature_titles_container_mobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column-reverse",
    gap: "8px",
    width: "100%",
    marginBottom: "12px",
  },

  buttons_container_container: {
    width: "100%",
    margin: "40px 0px",
  },

  //---------------------- Laptop -----------------------

  rightSide_laptop: {
    height: "100vh",
  },

  footer: {
    width: "100%",
    marginBottom: "20px",
    [theme.breakpoints.down("desktop")]: {
      // marginTop: 40,
    },
  },
}));

export default useStyles;
